console.log('CART ADDON CLEANUP LOADED');

// Quantity at which the Standard Setup Service becomes free and is removed
// from the cart (matches ARTWORK_UNLOCK_QTY on the product page).
const STANDARD_SETUP_FREE_QTY = 12;

// Standard Setup Service variant ID — must match ADDON_IDS.standardArtwork
// on the product page. Confirm this against your Shopify admin.
const STANDARD_SETUP_ADDON_ID = 53622986080563;
const STANDARD_SETUP_FEE = 50;

// RE-ENTRANCY GUARD — prevents two overlapping cleanupAddons() calls from
// both reading the "old" cart state and both deciding to add the Standard
// addon back, which produced duplicate (quantity 2) line items.
let cleanupInProgress = false;

async function cleanupAddons() {

    if (cleanupInProgress) {
        console.log('Cleanup already running — skipping this call');
        return;
    }

    cleanupInProgress = true;

    try {

        const cart =
            await fetch('/cart.js')
            .then(r => r.json());

        console.log('Cart:', cart);

        const hatItems =
            cart.items.filter(
                item =>
                    item.properties &&
                    item.properties._item_type === 'hat'
            );

        const addonItems =
            cart.items.filter(
                item =>
                    item.properties &&
                    item.properties._item_type === 'addon'
            );

        console.log(
            'Hat Items:',
            hatItems.length
        );

        console.log(
            'Addon Items:',
            addonItems.length
        );

        const updates = {};
        const itemsToAdd = [];

        // GROUP HAT TOTALS BY CONFIG

        const configTotals = {};

        hatItems.forEach(hat => {

            const configId =
                hat.properties?._config_id;

            if (!configId) {
                return;
            }

            configTotals[configId] =
                (configTotals[configId] || 0)
                + hat.quantity;

        });

        console.log(
            'CONFIG TOTALS:',
            configTotals
        );

        // HANDLE ADDONS

        addonItems.forEach(addon => {

            const configId =
                addon.properties?._config_id;

            const addonType =
                addon.properties?.['Addon Type'] || '';

            const totalHatQty =
                configTotals[configId] || 0;

            // STANDARD SETUP SERVICE — becomes FREE at 12+ hats, so once that
            // threshold is hit we remove the line item entirely instead of
            // leaving a redundant $0 charge sitting in the cart.

            if (addonType.includes('Standard')) {

                if (
                    totalHatQty === 0 ||
                    totalHatQty >= STANDARD_SETUP_FREE_QTY
                ) {

                    console.log(
                        'REMOVING STANDARD SETUP (free at 12+ or orphaned):',
                        addon.product_title,
                        'qty:', totalHatQty
                    );

                    updates[addon.key] = 0;

                }

                return;

            }

            // PREMIUM SETUP SERVICE — stays at qty 1 regardless of hat count
            // (it becomes free at 48+ per the pricing tiers, but the line item
            // itself is still charged/shown, just at $0) — only remove if orphaned.

            if (addonType.includes('Premium')) {

                if (
                    totalHatQty === 0
                ) {

                    updates[addon.key] = 0;

                }

                return;

            }

            // REMOVE ORPHAN ADDONS

            if (
                totalHatQty === 0
            ) {

                console.log(
                    'REMOVING ORPHAN:',
                    addon.product_title
                );

                updates[addon.key] = 0;

                return;

            }

            // SYNC ADDON QTY

            if (
                addon.quantity !== totalHatQty
            ) {

                console.log(
                    'SYNCING:',
                    addon.product_title,
                    addon.quantity,
                    '→',
                    totalHatQty
                );

                updates[addon.key] =
                    totalHatQty;

            }

        });

        // RE-ADD STANDARD SETUP SERVICE IF A CONFIG DROPPED BACK BELOW 12
        // AND HAS NO SETUP-SERVICE ADDON (STANDARD OR PREMIUM) AT ALL —
        // e.g. it was previously removed above because qty hit 12+, and the
        // customer has since reduced the quantity back down.

        Object.keys(configTotals).forEach(configId => {

            const totalHatQty = configTotals[configId];

            if (totalHatQty === 0 || totalHatQty >= STANDARD_SETUP_FREE_QTY) {
                return;
            }

            const hasSetupAddon = addonItems.some(addon => {
                const addonType = addon.properties?.['Addon Type'] || '';
                return (
                    addon.properties?._config_id === configId &&
                    (addonType.includes('Standard') || addonType.includes('Premium'))
                );
            });

            if (!hasSetupAddon) {

                console.log(
                    'RE-ADDING STANDARD SETUP for config:',
                    configId,
                    'qty:', totalHatQty
                );

                itemsToAdd.push({
                    id: STANDARD_SETUP_ADDON_ID,
                    quantity: 1,
                    properties: {
                        '_config_id': configId,
                        '_item_type': 'addon',
                        'Addon Type': 'Standard Setup Service',
                        'Setup Service Charge': '$' + STANDARD_SETUP_FEE
                    }
                });

            }

        });

        const hasUpdates = Object.keys(updates).length > 0;
        const hasAdds = itemsToAdd.length > 0;

        if (hasUpdates || hasAdds) {

            if (hasUpdates) {

                console.log(
                    'UPDATING CART:',
                    updates
                );

                await fetch(
                    '/cart/update.js',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type':
                                'application/json'
                        },
                        body: JSON.stringify({
                            updates
                        })
                    }
                );

            }

            if (hasAdds) {

                console.log(
                    'ADDING ITEMS TO CART:',
                    itemsToAdd
                );

                await fetch(
                    '/cart/add.js',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type':
                                'application/json'
                        },
                        body: JSON.stringify({
                            items: itemsToAdd
                        })
                    }
                );

            }

            // RELOAD PAGE AFTER 1 SECONDS TO REFLECT CHANGES
                window.location.reload();

            // NOTE: intentionally not resetting cleanupInProgress here —
            // the page reload below wipes all JS state anyway, so there's
            // no window for a duplicate run to sneak in after a successful
            // update/add.

        }

    }

    catch (e) {

        console.error(
            'Cleanup failed',
            e
        );

    }

    finally {

        // Only release the guard if we did NOT reload the page above.
        // (If we did reload, this line still runs but is harmless since
        // the whole script re-initializes fresh on the new page load.)
        cleanupInProgress = false;

    }

}

// SHARED DEBOUNCE — all triggers (remove button, quantity change, and the
// MutationObserver) funnel through this single timer so near-simultaneous
// triggers collapse into ONE cleanupAddons() call instead of several
// independent ones racing each other.

function scheduleCleanup(delay = 1500) {

    clearTimeout(window._cleanupTimer);

    window._cleanupTimer = setTimeout(() => {
        cleanupAddons();
        updateRemoveButtons();
    }, delay);

}

// REMOVE BUTTON

document.addEventListener(
    'click',
    function (e) {

        const removeBtn =
            e.target.closest(
                'cart-remove-button a'
            );

        if (!removeBtn) {
            return;
        }

        console.log(
            'REMOVE BUTTON CLICKED'
        );

        scheduleCleanup();

    }
);

// QUANTITY CHANGES

document.addEventListener(
    'change',
    function (e) {

        const qtyInput =
            e.target.closest(
                'input[name="updates[]"]'
            );

        if (!qtyInput) {
            return;
        }

        console.log(
            'QUANTITY CHANGED'
        );

        scheduleCleanup();

    }
);

function updateRemoveButtons() {

    const cartItems = document.querySelectorAll('.cart-item');

    // COUNT ONLY HAT ROWS (non-addon)
    const hatRows = Array.from(cartItems).filter(row => {
        return !row.classList.contains('addon-item');
    });

    hatRows.forEach((row, index) => {
        const removeBtn = row.querySelector('cart-remove-button');
        if (!removeBtn) return;

        // ONLY ONE HAT — show button (lets them clear cart)
        if (hatRows.length === 1) {
            removeBtn.style.display = '';
            return;
        }

        // MULTIPLE HATS — hide last one (it has all the order info)
        if (index === hatRows.length - 1) {
            removeBtn.style.display = 'none';
        } else {
            removeBtn.style.display = '';
        }

    });

}
// CART OBSERVER
const cartObserver = new MutationObserver(() => {
    console.log('Cart DOM changed — running cleanup');
    scheduleCleanup();
});

document.addEventListener('DOMContentLoaded', () => {

    const cartContainer = document.getElementById('main-cart-items');

    if (cartContainer) {
        cartObserver.observe(cartContainer, {
            childList: true,
            subtree: true
        });
    }

    // RUN BOTH ON LOAD
    cleanupAddons();
    updateRemoveButtons();

});
